import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../helpers/axiosConfig";
import { ACCOUNT_API, API } from '../../helpers/consts';
import { getAccessToken, getTotalPages, getTotalPagesPublic } from "../../helpers/functions";

export const getPetitions = createAsyncThunk(
    'petitions/getPetitions',
    async (_, { getState }) => {
        try {
            const { currentPage, search, currentTags } = getState().petitions;
            // const searchParams = `search=${search}${currentTags && `tags=${currentTags}`}`;
            let searchParams = `search=${search}`;
            if (currentTags && currentTags.length > 0) {
                searchParams += `&tags=${currentTags}`;
            }
            const pagesLimitParams = `?page=${currentPage}&limit=10`;
            const totalPages = await getTotalPagesPublic();
            const { data } = await api.get(`/petition/${pagesLimitParams}&${searchParams}`);
            return { data, totalPages };
        } catch (err) {
            throw err;
        }
    }
);

export const getMyPetitions = createAsyncThunk(
    'petitions/getMyPetitions',
    async (_, { getState, rejectWithValue }) => {
        try {
            const { myCurrentPage } = getState().petitions;
            const pagesLimitParams = `?page=${myCurrentPage}&limit=10`;
            const totalPages = await getTotalPages(`${API}/mypetition/`);
            const res = await api.get(`/mypetition/${pagesLimitParams}`);
            if (res.status === 200) {
                return { res, totalPages };
            }
        } catch (err) {
            return rejectWithValue(err.response.data)
        }
    }
);

export const getOnePetition = createAsyncThunk(
    'petitions/getOnePetition',
    async ({ id }) => {
        try {
            const { data } = await api.get(`/petition/${id}/`);
            return { data };
        } catch (err) {
            throw err;
        }
    }
);


export const getMyPetition = createAsyncThunk(
    'petitions/getMyPetition',
    async ({ id }) => {
        try {
            const { data } = await api.get(`/mypetition/${id}/`);
            return { data };
        } catch (err) {
            throw err;
        }
    }
);

export const editPetition = createAsyncThunk(
    'petitions/editPetition',
    async ({ petition }, { dispatch }) => {
        try {
            const formData = new FormData();
            formData.append('title', petition.title);
            formData.append('description', petition.description);
            formData.append('image', petition.image);
            const { data } = await api.patch(`/api/petition/${petition.id}/`, formData);
            dispatch(getPetitions());
        } catch (err) {
        }
    }
);

export const deletePetition = createAsyncThunk(
    'petitions/deletePetition',
    async ({ id, navigate }) => {
        try {
            const { data } = await api.delete(`/mypetition/${id}/`);
            if (data === 'Петиция удалена') {
                return { navigate }
            } else {
                return data
            }
        } catch (err) {
            throw err;
        }

    }
)


export const createPetition = createAsyncThunk(
    'petitions/createPetition',
    async ({ petition, navigate }, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "content-type": "multipart/form-data",
                },
            };
            const formData = new FormData();
            if (petition.image instanceof File) {
                formData.append('image', petition.image);
            }
            formData.append('title', petition.title);
            formData.append('description', petition.description);
            const res = await api.post('/mypetition/', formData, config);
            return { res, navigate }
        } catch (err) {
            return rejectWithValue(err.response.data)
        }
    }
);
export const createPreviewPetition = createAsyncThunk(
    'petitions/createPreviewPetition',
    async ({ previewPetition, navigate }) => {
        try {
            const formData = new FormData();
            formData.append('title', previewPetition.title);
            formData.append('description', previewPetition.description);
            formData.append('image', previewPetition.image);
            const { data } = await axios.post(`${ACCOUNT_API}/mypetition/`, formData, {
                headers: {
                    "Authorization": `Token ${getAccessToken()}`,
                    "Content-Type": "multipart/form-data"
                }
            })
            return { data, navigate }
        } catch (err) {
        }
    }
);

export const votePetition = createAsyncThunk(
    'petitions/votePetition',
    async ({ onePetition, choice }, { dispatch, rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('title', onePetition.title);
            formData.append('description', onePetition.description);
            formData.append('id', onePetition.id);
            formData.append('choice', choice);
            const res = await api.put(`/petition/${onePetition.id}/`, formData);
            if (res.status === 200) {
                dispatch(getOnePetition({ id: onePetition.id }))
                //return res.data;
            }
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
)

export const voteMyPetition = createAsyncThunk(
    'petitions/voteMyPetition',
    async ({ myPetition, choice }, { dispatch }) => {
        try {
            const formData = new FormData();
            formData.append('title', myPetition.title);
            formData.append('description', myPetition.description);
            formData.append('id', myPetition.id);
            formData.append('choice', choice);
            const { data } = await api.put(`/petition/${myPetition.id}/`, formData);
            // dispatch(getMyPetition({id: myPetition.id}))
        } catch (err) {
            throw err;
        }
    }
)

export const deleteVote = createAsyncThunk(
    'petitions/deleteVote',
    async ({ onePetition }, { dispatch, rejectWithValue }) => {
        try {
            const res = await api.delete(`/petition/${onePetition.id}/`);
            if (res.status === 200) {
                dispatch(getOnePetition({ id: onePetition.id }))
                return res.data;
            }
        } catch (err) {
            rejectWithValue(err.response.data);
        }
    }
)

export const deleteMyVote = createAsyncThunk(
    'petitions/deleteVote',
    async ({ myPetition }, { dispatch }) => {
        try {
            const { data } = await api.delete(`/petition/${myPetition.id}/`);
        } catch (err) {
            throw err;
        }
    }
)

export const getTags = createAsyncThunk(
    'petitions/getTags',
    async () => {
        try {
            const { data } = await axios.get(`${API}/tags/`);
            return data;
        } catch (err) {
            throw err;
        }
    }
)